<div class="row m-0">
  <p>{{ header }}</p>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  <button mat-raised-button class="close-btn w-100" (click)="dialogRef.close()">Cancel</button>
</div>
